import React, {useEffect, useMemo, useState} from 'react';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import {Filter, Node} from "../types";
import {readQueryParams, searchParam} from "../epic/searchEpic";
import {useLocation} from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import BlockUi from '@availity/block-ui';
import { FormGroup } from 'react-bootstrap';
import FormLabel from '@mui/material/FormLabel';
import { useUpdateQueryParam } from '../hook';
import { CircularProgress } from '@mui/material';


interface Props {
    list: Node[]
    collectionsLoading: boolean
    field: "marqueEditoriale" | "division"
    label: string
}

export const MarqueOrDivisionFilter = ({
    list, collectionsLoading, field, label
}: Props) => {
    const searchLocation = useLocation().search;
    const checked = useMemo(() => readQueryParams(searchParam, searchLocation), [searchLocation]) as Filter
    const init: string[] = [];
    const [expanded, setExpanded] = useState(init);
    const [selectAll, setSelectAll] = useState(false);
    const handleUpdateQueryParam = useUpdateQueryParam();


    useEffect(() => {
        const allChecked = checked[field] && checked[field].length === list.length;
        setSelectAll(allChecked);
      }, [checked, list, field]);

    const handleCheck = (checkedItems: string[]) => {

        setSelectAll(checkedItems.length === list.length);

        handleUpdateQueryParam(field, checkedItems)
    };

    const handleSelectAllChange = () => {
        const updatedCheckboxes = !selectAll ? list.map(
            (marque) => marque.value
        ) : [];
        setSelectAll(!selectAll);
    
        handleUpdateQueryParam(field, updatedCheckboxes)
      };
    
      const indeterminate = checked[field] && checked[field].length > 0 && checked[field].length < list.length;

    return (
        <FormControl component="fieldset" sx={{margin: '2px 0'}}>
            <BlockUi loader={<CircularProgress size="1rem"/>} blocking={collectionsLoading}>
                <FormGroup>
                <FormLabel component="legend" style={{marginBottom: 0}}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                indeterminate={indeterminate}
                                checked={selectAll}
                                onChange={handleSelectAllChange}
                            />
                        }
                        label={label}
                    />
                    </FormLabel>
                    <div className="marque-editorial">
                        <CheckboxTree
                            nodes={list}
                            checked={checked[field]}
                            onCheck={checked => handleCheck(checked)}
                            expanded={expanded}
                            onExpand={ex => setExpanded(ex)}
                        />
                    </div>
                </FormGroup>
            </BlockUi>
        </FormControl>
    )
}
